export default __webpack_public_path__ + "static/media/Logo.eff48c82.png";